import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-animation',
  templateUrl: './error-animation.component.html',
  styleUrls: ['./error-animation.component.scss']
})
export class ErrorAnimationComponent implements OnInit {

  @Input() text!: string;

  constructor() { }

  ngOnInit() {
  }

}
